export var AdminRoles;
(function (AdminRoles) {
    AdminRoles["editor"] = "editor";
    AdminRoles["courier"] = "courier";
    AdminRoles["switchAsOwner"] = "switch_as_owner";
})(AdminRoles || (AdminRoles = {}));
